import type { User } from "@/types";

export interface AuthState {
  token: string | null;
  user: User | null;
  projectId: string | null;
  permissions: string[];
  loading: boolean;
}

export type AuthAction =
  | { type: "profileLoadStarted" }
  | { type: "profileLoaded"; user: User; projectId: string | null; permissions?: string[] }
  | { type: "sessionStarted"; token: string }
  | { type: "sessionCleared" };

export function createInitialAuthState(token: string | null): AuthState {
  return {
    token,
    user: null,
    projectId: null,
    permissions: [],
    loading: Boolean(token),
  };
}

export function authStateReducer(
  state: AuthState,
  action: AuthAction,
): AuthState {
  switch (action.type) {
    case "profileLoadStarted":
      return state.token ? { ...state, loading: true } : clearAuthState;
    case "profileLoaded":
      return {
        ...state,
        user: action.user,
        projectId: action.projectId,
        permissions: action.permissions ?? state.permissions,
        loading: false,
      };
    case "sessionStarted":
      return {
        token: action.token,
        user: null,
        projectId: null,
        permissions: [],
        loading: true,
      };
    case "sessionCleared":
      return clearAuthState;
  }
}

const clearAuthState: AuthState = {
  token: null,
  user: null,
  projectId: null,
  permissions: [],
  loading: false,
};
